module.exports = __webpack_public_path__ + "static/img/logo_black.13e9816.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/logo_black.png
// module id = I7r6
// module chunks = 0